import { PositionResult } from "common/position/dto/PositionResult";
import SearchResultList, {
  PageNavigation,
} from "components/common/SearchResultList";
import PositionItem from "./PositionItem";
import { useUnosPositionSearch } from "hooks/unos/position/useUnosPositionSearch";
import { POSITION_PER_PAGE_MAX } from "constant/position";
import { useEffect, useState } from "react";
import { PositionSearchParams } from "common/api/unos_rad/unos_position";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";
import { QUERY_KEYS } from "constant/react_query";
import { positionSearchFieldsGet } from "common/position/position_search";
import PositionSearchFilters from "components/common/position/PositionSearchFilters";
import { SEARCH_NAMES } from "constant/search";

const PositionList = () => {
  const [searchParams, setSearchParams] = useState<PositionSearchParams>({
    [SEARCH_NAMES.LIMIT]: POSITION_PER_PAGE_MAX,
    [SEARCH_NAMES.SKIP]: 0,
  });
  const positionListResult = useUnosPositionSearch(searchParams);
  const invalidateQuery = useInvalidateQueryByKeys();
  useEffect(() => {
    invalidateQuery.invalidateQueriesByKeys([QUERY_KEYS.UNOS_POSITION_SEARCH]);
  }, [searchParams]);

  let results: PositionResult[] = positionListResult
    ? positionListResult["items"]
    : [];
  const resTotal: number = positionListResult
    ? positionListResult["resTotal"]
    : 0;
  const pageNavigationHandle = (pageNum: number) => {
    const skip = pageNum * POSITION_PER_PAGE_MAX;
    setSearchParams({ ...searchParams, skip });
  };
  const pageNavigation: PageNavigation = {
    resTotal,
    limit: POSITION_PER_PAGE_MAX,
    skip: searchParams.skip ?? 0,
    pageNavigationHandle,
  };

  const searchHandle = (formData: any) => {
    const searchVals = positionSearchFieldsGet(formData);

    setSearchParams({
      ...searchParams,
      ...searchVals,
      skip: 0,
    });
  };

  return (
    <div>
      <PositionSearchFilters searchHandle={searchHandle} />
      <SearchResultList<PositionResult>
        renderSingle={(position: PositionResult) => (
          <PositionItem position={position} key={`position${position.id}`} />
        )}
        results={results}
        pageNavigation={pageNavigation}
      />
    </div>
  );
};

export default PositionList;
